import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39ebbebb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "incredicon-edit-table !text-[20px] mr-2" }, null, -1))
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-b-System/app_border bg-System/app_white sticky top-0" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-gordita-medium text-[14px] leading-[19px] py-[11px] px-[16px]" }, "Manage Columns")
], -1))
const _hoisted_4 = { class: "flex items-center w-full" }
const _hoisted_5 = { class: "flex w-full" }
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = { class: "flex grow flex-wrap items-center h-[32px]" }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = { class: "flex flex-wrap items-center h-[32px]" }
const _hoisted_10 = { class: "w-[15px]" }
const _hoisted_11 = {
  key: 0,
  class: "ml-auto cursor-grab active:cursor-grabbing text-Text/text_lowest text-[15px] leading-[20px] uil uil-draggabledots handle",
  "data-testid": "manage-columns--drag-handle"
}
const _hoisted_12 = { class: "border-t border-t-System/app_border" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reset to Default", -1))

import { computed, inject, ref, watch } from 'vue';
import { IncrediField, IncrediButton, IncrediCard, IncrediCheckbox, IncrediDraggableList, IncrediItem, IncrediList, IncrediMenu, IncrediTooltip } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import elementIds from '@/const/elementIds.json';
import { useOsService } from '@/services/OsService/OsService';
import { useWorkloadsColumnsManagement } from '@/views/workloads/components/navbarComponents/manageColumns/manage-columns.helpers';
import { columnOrder, ColumnsFilter, TableColumn } from '@/views/workloads/workloads-table.types';
import { useWorkloadsTableConstants } from '@/views/workloads/workloads.const';
import { MatomoAgentsActions, MatomoCategories } from '@/services/matomo/matomo.const';
import { useMatomo } from '@/services/matomo/matomo.service';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { Builds_SortOrder } from '@/graphql/codegen/generated/graphql';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { useWorkloadsTableUtils } from '@/views/workloads/workloads.utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-workloads-table',
  setup(__props) {

const osService = useOsService();
const workloadsPageData = inject(IKWorkloadsPageData);
const unSelectedDirtyColumns = ref<columnOrder[]>([]);
const tableData = useWorkloadsColumnsManagement();
const workloadsConstants = useWorkloadsTableConstants();
const { handleDynamicColumns } = useWorkloadsTableUtils();
const editTable = tableData?.tableEditor;
const menu = ref(false);
const searchColumns = ref('');
const isSpecialRowHovered = ref(false);
const searchColumnsInputFocused = ref(false);
const matomo = useMatomo();

const workloadsColumnsTooltipColumns = computed(() => [workloadsConstants.COLUMNS_NAMES[OsType.Windows].readyOverActiveRatio]);
const shouldShowSpecialTooltip = (column: TableColumn) => workloadsColumnsTooltipColumns.value.includes(column.name);

const handleColumnSelection = (column: TableColumn) => {
  const isSelected = !editTable?.get[osService.osType.value].value.columnsFilter[column.name];
  matomo?.trackEvent({
    category: MatomoCategories.Workloads,
    action: MatomoAgentsActions.ColumnSelection,
    name: column.name,
    value: isSelected ? 1 : 0,
  });

  const defaultColumnData = workloadsConstants.columns.value.filter(defaultCol => defaultCol.name === column.name)[0];
  if (editTable) {
    const { columnsOrder } = editTable.get[osService.osType.value].value;
    editTable.set[osService.osType.value]({
      // Set default column's width to default for both actions: select and unselect
      columnsOrder: [...columnsOrder.filter((orderedColumn: any) => orderedColumn.name !== column.name), { ...column, width: defaultColumnData.width }],
      columnsFilter: { ...editTable.get[osService.osType.value].value.columnsFilter, [column.name]: isSelected },
    });
  }

  if (isSelected) {
    unSelectedDirtyColumns.value = unSelectedDirtyColumns.value.filter(dirtyColumn => dirtyColumn.name !== column.name);
  } else {
    if (workloadsConstants.WORKLOADS_COLUMNS_TO_SORT_MAP[osService.osType.value][column.name] === workloadsPageData?.filter?.get.value.sort?.field) {
      workloadsPageData?.filter?.set({
        ...workloadsPageData?.filter?.get.value,
        sort: {
          ...workloadsPageData?.filter?.get.value.sort,
          field: workloadsConstants.WORKLOADS_COLUMNS_TO_SORT_MAP[OsType.Windows][workloadsConstants.COLUMNS_NAMES[OsType.Windows].startTime], // relevant for both OS
          order: Builds_SortOrder.Descending,
        },
      });
    }
    unSelectedDirtyColumns.value.unshift(column as any);
  }
};

const columnsManagementMenuHandler = (isOpen: boolean) => {
  menu.value = isOpen;
  unSelectedDirtyColumns.value = [];
};

// Method to rest columns data to their default values
const resetToDefault = () => {
  tableData?.resetColumnsToDefault();
  unSelectedDirtyColumns.value = [];
  matomo?.trackEvent({
    category: MatomoCategories.Workloads,
    action: MatomoAgentsActions.ColumnSelectionReset,
  });
};

const handleDragColumn = (
  columnsOrder:
    | NonNullable<typeof editTable>['get']['windows']['value']['columnsOrder']
    | NonNullable<typeof editTable>['get']['linux']['value']['columnsOrder']
    | NonNullable<typeof editTable>['get']['mac']['value']['columnsOrder'],
) => {
  if (editTable)
    editTable.set[osService.osType.value]({
      ...editTable.get[osService.osType.value].value,
      columnsOrder,
    });
};

const columnsOrder = computed(() => {
  const selectedColumns = editTable?.get[osService.osType.value].value.columnsOrder?.filter((column: any) => editTable?.get[osService.osType.value].value.columnsFilter[column.name]);
  const unSelectedColumns = editTable?.get[osService.osType.value].value.columnsOrder
    .filter((column: any) => !unSelectedDirtyColumns.value.find(dirtyColumn => dirtyColumn.name === column.name) && !editTable?.get[osService.osType.value].value.columnsFilter[column.name])
    .sort((a: any, b: any) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  return [...(selectedColumns || []), ...unSelectedDirtyColumns.value, ...(unSelectedColumns || [])];
});

const columnsOrderFiltered = computed(() => handleDynamicColumns(columnsOrder.value).filter(column => column.name.toLowerCase().includes(searchColumns.value.toLowerCase())));

watch(
  () => menu.value,
  newValue => {
    if (!newValue) {
      searchColumns.value = '';
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IncrediMenu), {
      "model-value": menu.value,
      direction: 'bottom-sticky-right',
      "offset-y": 4,
      "onUpdate:modelValue": columnsManagementMenuHandler
    }, {
      content: _withCtx(() => [
        _createVNode(IbxScopedCss, null, {
          default: _withCtx(() => [
            _createVNode(_unref(IncrediCard), {
              class: "w-[280px] rounded-[2px]",
              "data-testid": _unref(elementIds).workloads.manageColumnsList
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_unref(IncrediField), {
                  modelValue: searchColumns.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchColumns).value = $event)),
                  class: _normalizeClass(["my-2 mx-1", [searchColumns.value ? 'text-Text/text_high' : 'text-Text/text_low']]),
                  "data-testid": _unref(elementIds).workloads.workloadsSortByMenuSearchInput,
                  name: "search",
                  label: "Search",
                  size: "tiny",
                  clearable: "",
                  onFocusWithin: _cache[1] || (_cache[1] = ($event: any) => (searchColumnsInputFocused.value = true)),
                  onBlurWithin: _cache[2] || (_cache[2] = ($event: any) => (searchColumnsInputFocused.value = false))
                }, {
                  prepend: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(["uil uil-search text-[20px] mr-[10px]", [searchColumnsInputFocused.value ? 'text-System/app_primary' : 'text-Text/text_low']])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "data-testid"]),
                _createVNode(_unref(IncrediList), { class: "!shadow-none overflow-auto max-h-[34vh] mb-[3px] !pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IncrediDraggableList), {
                      "model-value": _unref(columnsOrderFiltered),
                      "item-key": "name",
                      handle: ".handle",
                      "onUpdate:modelValue": handleDragColumn
                    }, {
                      item: _withCtx(({ item: column }: { item: TableColumn }) => [
                        _createVNode(_unref(IncrediTooltip), {
                          hover: "",
                          "model-value": shouldShowSpecialTooltip(column) && isSpecialRowHovered.value,
                          direction: "middle-left"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.manageColumns.unmetHelperRequestsTooltip.a')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.manageColumns.unmetHelperRequestsTooltip.b')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(IncrediItem), {
                                  class: "w-full py-0 !px-[4px]",
                                  style: {"padding-top":"0px","padding-bottom":"0px"},
                                  "data-testid": `item-row-${column.name}`,
                                  onMouseenter: 
                            () => {
                              if (shouldShowSpecialTooltip(column)) {
                                isSpecialRowHovered.value = true;
                              }
                            }
                          ,
                                  onMouseleave: 
                            () => {
                              if (shouldShowSpecialTooltip(column)) {
                                isSpecialRowHovered.value = false;
                              }
                            }
                          
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_unref(IncrediCheckbox), {
                                          "data-checkbox-id": column.name,
                                          size: "small",
                                          design: "primary-green",
                                          "model-value": !!(_unref(editTable)?.get[_unref(osService).osType.value].value.columnsFilter as ColumnsFilter)[column.name],
                                          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                                          "onUpdate:modelValue": (val) => handleColumnSelection(column)
                                        }, null, 8, ["data-checkbox-id", "model-value", "onUpdate:modelValue"]),
                                        _createElementVNode("span", {
                                          "data-testid": column.name,
                                          class: "ml-[3px] select-none"
                                        }, _toDisplayString(column.name), 9, _hoisted_8),
                                        (shouldShowSpecialTooltip(column))
                                          ? (_openBlock(), _createElementBlock("i", {
                                              key: 0,
                                              class: _normalizeClass(["ml-[4px] text-[16px] text-Text/text_low", isSpecialRowHovered.value ? 'uis uis-info-circle' : 'uil uil-info-circle'])
                                            }, null, 2))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                          ((_unref(editTable)?.get[_unref(osService).osType.value].value.columnsFilter)[column.name] && !searchColumns.value)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["data-testid", "onMouseenter", "onMouseleave"])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["model-value"])
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(IncrediButton), {
                    "data-testid": "reset-to-default-button",
                    class: "p-[8px] reset-button",
                    design: "ghost-green",
                    size: "tiny",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (resetToDefault()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["data-testid"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(IncrediButton), {
          class: "whitespace-nowrap flex flex-nowrap items-center !text-Text/text_high edit-table--button radius-[2px] !px-[4px]",
          design: "master",
          size: "small",
          selected: menu.value
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("span", {
              class: "manage-columns-title text-[12px]",
              "data-testid": _unref(elementIds).workloads.manageColumnsButton
            }, " Manage Columns ", 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["selected"])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})